const todoDatas = [
    {
        id: 1,
        text: "Half hour of Yoga",
        completed: true
    },
    {
        id: 2,
        text: "Learn new chords in guitar",
        completed: false
    },
    {
        id: 3,
        text: "Complete React Scrimba",
        completed: false
    },
    {
        id: 4,
        text: "Practice questions from HackerRank  .",
        completed: false
    },
    {
        id: 5,
        text: " Python course from udemy. ",
        completed: true
    }

]
export default todoDatas